import * as React from "react";
import { connect } from "react-redux";
import { showReturnDialog, activeStep, returnDialogStateSelector } from "../../reducers/controlReducer";
import { Modal, Button } from "react-bootstrap";

const ReturnDialog = (props) => {
  const onPreviousClickHandler = () => {
    props.updateActiveStep({ activeStep: 1 });
    //props.onPreviousClick(true);
  };

  return (
    <div>
      <Modal {...props} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You will lose translations. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => props.onPreviousClick(false)}>No</Button>
          <Button onClick={() => onPreviousClickHandler()}>Yes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPreviousClick: (isOpen) => dispatch(showReturnDialog(isOpen)),
    //updateActiveStep: (activeStep) => dispatch(updateStepperState(activeStep)),
    updateActiveStep: (step) => dispatch(activeStep(step)),
    // updateStepperState: (activeStep) => dispatch(updateStepperState(activeStep)),
    // updateFileToDownload: (segments) => dispatch(updateFileToDownload(segments)),
  };
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnDialog);
